import React, { useMemo } from "react";
import BarChart from "../Charts/BarChart";
import { getValueByPath } from "../Meta/metaUtils";

const MINI_BAR_DEFAULT_THEME = {
  orientation: "vertical",
  distributed: false,
  columnWidth: "65%",

  barColor: "#FFE7CD",
  highlightColor: "#FF8400",

  xAxisLabelColor: "#353535",
  xAxisLabelFontSize: "18px",
  xAxisLabelFontWeight: 400,

  showXAxisLine: true,
  showYAxisLine: false,
  showYAxisLabels: false,
  showGridX: false,
  showGridY: false,
  showXAxisLabels: true,
  showBarValues: true,
  showLegend: false,

  barValueFormatter: (v) => v,
};

function resolveNumber(dataContext, path, fallback = 0) {
  if (!path) return fallback;
  const val = getValueByPath(dataContext, path);
  return Number(val ?? fallback);
}

export default function MiniBarStatCard({
  dataContext,
  theme = {},
  meta = {},
}) {
  const totalValue = useMemo(() => {
    if (!meta?.primaryValue?.path) return null;
    return resolveNumber(dataContext, meta.primaryValue.path, 0);
  }, [dataContext, meta?.primaryValue?.path]);

  // Bar data
  const chartData = useMemo(() => {
    const items = Array.isArray(theme.items) ? theme.items : [];
    return items.map((item) => ({
      name: item.label,
      value: resolveNumber(dataContext, item.path, 0),
    }));
  }, [dataContext, theme.items]);

  const barTheme = useMemo(() => {
    return {
      ...MINI_BAR_DEFAULT_THEME,
      ...theme, 
    };
  }, [theme]);

  return (
    <div className="w-full h-full">
      {/* totalvalue */}
      {meta?.primaryValue?.visible !== false && totalValue !== null && (
        <div className="text-base font-semibold mb-6">{totalValue}</div>
      )}

      {/* Mini Bar Chart */}
      <div className="h-[230px]">
        <BarChart data={chartData} dataContext={dataContext} theme={barTheme} />
      </div>
    </div>
  );
}











// import React, { useMemo } from "react";
// import BarChart from "../Charts/BarChart";
// import { getValueByPath } from "../Meta/metaUtils";

// /**
//  * MiniBarStatCard
//  * - KPI from meta.primaryValue
//  * - Bars from theme.items[]
//  * - Integer labels
//  * - Layout-config driven
//  */
// export default function MiniBarStatCard({
//   dataContext,
//   theme = {},
//   meta = {},
// }) {
//   /* ---------- KPI ---------- */
//   const totalValue = useMemo(() => {
//     if (!meta?.primaryValue?.path) return null;
//     return Number(getValueByPath(dataContext, meta.primaryValue.path) ?? 0);
//   }, [dataContext, meta]);

//   /* ---------- BAR DATA ---------- */
//   const chartData = useMemo(() => {
//     return (theme.items || []).map(item => ({
//       name: item.label,
//       value: Number(getValueByPath(dataContext, item.path) ?? 0),
//     }));
//   }, [dataContext, theme.items]);

//   return (
//     <div className="w-full h-full">
//       {/* KPI */}
//       {totalValue !== null && (
//         <div className="text-base font-semibold mb-6">
//           {totalValue}
//         </div>
//       )}

//       {/* MINI BAR CHART */}
//       <div className="h-[230px]">
//         <BarChart
//           data={chartData}
//           theme={{
//             distributed: false,
//             /* layout */
//             orientation: "vertical",
//             columnWidth: theme.columnWidth ?? "65%",

//             /* colors */
//             barColor: theme.barColor ?? "#FFE7CD",
//             highlightColor: theme.highlightColor ?? "#FF8400",

//             /* X-axis label styling */
//             xAxisLabelColor: theme.xAxisLabelColor ?? "#353535",
//             xAxisLabelFontSize: theme.xAxisLabelFontSize ?? "18px",
//             xAxisLabelFontWeight: theme.xAxisLabelFontWeight ?? 400,

//             /* visibility */
//             showXAxisLine: true,
//             showYAxisLine: false,
//             showYAxisLabels: false,
//             showGridX: false,
//             showGridY: false,
//             showXAxisLabels: true,
//             showBarValues: true,
//             showLegend: false,

//             barValueFormatter: (val) => val,
//           }}
//         />
//       </div>
//     </div>
//   );
// }
